// Preserve in-progress writing, radio votes, selection and keyboard focus when
// a WebSocket broadcast refreshes the screen. Values never become HTML.
const fields = (root) => [...root.querySelectorAll('input, textarea, select')];
const key = (field) => JSON.stringify([field.form?.id || '', field.name || field.id, field.type === 'radio' ? field.value : '']);

export function captureFormDraft(root) {
  const draft = new Map();
  for (const field of fields(root)) {
    if (!field.name && !field.id) continue;
    draft.set(key(field), {
      value: field.value,
      checked: field.checked,
      focused: field === root.ownerDocument.activeElement,
      start: field.selectionStart,
      end: field.selectionEnd,
    });
  }
  return draft;
}

export function restoreFormDraft(root, draft) {
  if (!draft) return;
  for (const field of fields(root)) {
    const saved = draft.get(key(field));
    if (!saved || field.disabled) continue;
    if (field.type === 'radio' || field.type === 'checkbox') field.checked = saved.checked;
    else field.value = saved.value;
    if (saved.focused) {
      field.focus({ preventScroll: true });
      if (typeof saved.start === 'number' && typeof field.setSelectionRange === 'function') {
        try { field.setSelectionRange(saved.start, saved.end); } catch { /* Numeric inputs have no text selection. */ }
      }
    }
  }
}
